import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import style from './style'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

import { useHistory } from 'react-router-dom'
import axios from '../../Services/axios'
import swal from 'sweetalert2'

export default function InstituicaoEducacional(){
    const classes = style()

    const [isLoading, setIsLoading] = useState(true)
    const [instituicaoList, setInstituicaoList] = useState([])

    useEffect(() => {
        axios
            .get("instituicao")
            .then(({data}) => {
                setInstituicaoList(data.data)
                setIsLoading(false)
            })
            .catch(err => {
                console.log(err)
                // swal.fire("Falha ao carregar os dados")
            })
    }, [])

    const history = useHistory()
    return (
        <div>
            <Typography className={classes.title} variant="h1" >Cadastro de Instituição Educacional</Typography>

            <div className={classes.containerButton}>
                <Button variant="contained" color="primary" onClick={() => {
                    history.push("instituicaoEducacional/cadastrar")
                }}>
                  Criar novo
                </Button>
            </div>

            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>INEP</TableCell>
                            <TableCell align="center">Nome</TableCell>
                            <TableCell align="center">Tipo</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            isLoading ? (
                                <TableRow key={0}>
                                    <TableCell>Carregando...</TableCell>
                                </TableRow>
                            ): null
                        }
                        {
                            instituicaoList.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell component="td" scope="row">
                                        {row.inep}
                                    </TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{row.tipo}</TableCell>
                                    <TableCell>
                                        <IconButton aria-label="" onClick={() => {
                                            swal.fire({
                                                title: 'Tem certeza que deseja excluir?',
                                                text: "Você não poderá desfazer esta ação!",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Sim!'
                                              }).then((result) => {
                                                if (result.value) {
                                                    axios
                                                        .delete(`instituicao/${row.id}`)
                                                        .then(() => {
                                                            const newInstiuicoes = instituicaoList.filter(inst => inst.id !== row.id)
                                                            setInstituicaoList(newInstiuicoes)
                                                            swal.fire(
                                                              'Excluído!',
                                                              'Regsitro excluído com sucesso..',
                                                              'success'
                                                            )
                                                        })
                                                        .catch(err => {
                                                            console.log(err)
                                                            swal.fire("Falha ao excluir.")
                                                        })
                                                }
                                              })
                                        }}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                        <IconButton aria-label="" onClick={() => {
                                            history.push(`instituicaoEducacional/${row.id}/editar`)
                                        }}>
                                            <EditIcon color="action" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )) 
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}